module.exports = __webpack_public_path__ + "assets/img/kv-9f0e36e1.jpg";